import React from "react";
import PaymentDTO from "features/payments/dtos/PaymentDTO";
import { useTranslation } from "react-i18next";
import PageCard from "features/shared/components/card/PageCard";
import InfoItem from "features/shared/components/infoItem/InfoItem";
import { formatDate, formatPrice } from "features/shared/helpers/Formatters";

type Props = {
  financialSettlement: PaymentDTO;
};

const FinancialSettlementInfoCard = ({ financialSettlement }: Props) => {
  // translations
  const tLabels = useTranslation("payments\\payments").t;

  // render
  return (
    <PageCard
      title={tLabels("financialSettlementInfoCard.cardTitle")}
      bodyClassName="pb-0"
    >
      <div className="row no-gutters">
        <div className="col-sm-6 col-lg-4 px-sm-2 pb-2 pb-sm-3">
          <InfoItem
            title={tLabels("financialSettlementInfoCard.paymentDate")}
            value={formatDate(financialSettlement.paymentDate!)}
            icon="calendar-alt"
          />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-2 pb-2 pb-sm-3">
          <InfoItem
            title={tLabels(
              "financialSettlementInfoCard.financialSettlementNumber"
            )}
            value={financialSettlement.financialSettlementNumber}
            icon="tasks"
          />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem
            title={tLabels("financialSettlementInfoCard.amount")}
            value={formatPrice(
              financialSettlement.amount!,
              financialSettlement.currency!,
              2
            )}
            icon="money-bill-alt"
          />
        </div>
      </div>
    </PageCard>
  );
};

export default FinancialSettlementInfoCard;
